import axios from 'axios'

export default {
  // ======================================================================
  // ==========================List Management=============================
  // ======================================================================

  async list (context, opts) {
    try {
      const { data } = await axios.get('/api/system', { params: opts })
      context.commit('LIST', data)
    } catch (error) {
      console.log(error)
    }
  },
  purgeList (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/system/${opts}/purge`)
        .then(({ data }) => {
          context.commit('PURGE_LIST', data)
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  // ==========================Socket Updates==============================
  created (context, opts) {
    // if we're an admin, go fetch the new data
    axios
      .get(`/api/system/${opts}`)
      .then(({ data }) => {
        if (data.id) {
          context.commit('LIST_ADD', data)
          context.dispatch('Organization/healthStatus', {}, { root: true })
        }
      }).catch(() => {
      })
  },
  updated (context, opts) {
    // if it's in the list, go fetch its new details
    if (context.state.current.id === opts || context.state.list.find((i) => i.id === opts) !== undefined) {
      axios
        .get(`/api/system/${opts}`)
        .then(({ data }) => {
          if (data.id) {
            context.commit('LIST_UPDATE', data)
            if (data.id === context.state.current.id) {
              context.commit('CURRENT', data)
            }
          }
        }).catch(() => {
        })
    }
    context.dispatch('Organization/healthStatus', {}, { root: true })
  },
  destroyed (context, opts) {
    // always try to remove from list
    context.commit('LIST_REMOVE', opts)
    context.dispatch('Organization/healthStatus', {}, { root: true })
    if (opts === context.state.current.id) {
      context.commit('CURRENT', null)
    }
  },
  // ===========================List Edits===============================
  add (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/system', opts)
        .then(({ data }) => {
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  delete (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/system/${opts}`)
        .then(({ data }) => {
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  // ======================================================================
  // ==========================Item Management=============================
  // ======================================================================
  detail (context, opts) {
    const id = typeof opts === 'string' ? opts : opts && opts.id ? opts.id : '#'
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/system/${id}`)
        .then(({ data }) => {
          context.commit('CURRENT', data)
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  update (context, opts) {
    let id
    if (opts && opts.id) {
      id = opts.id
      delete opts.id
    } else {
      id = context.state.current.id
      opts = Object.assign({}, context.state.update)
      const current = Object.assign({}, context.state.current)
      for (const key of Object.keys(opts)) {
        if (opts[key] === current[key]) {
          delete opts[key]
        }
      }
    }
    if (opts && Object.keys(opts).length > 0) {
      return new Promise((resolve, reject) => {
        axios
          .patch(`/api/system/${id}`, opts)
          .then(({ data }) => {
            resolve(data)
          }).catch((error) => reject(error))
      })
    }
  },
  rpiUpdate (context, opts) {
    if (opts.id) {
      return new Promise((resolve, reject) => {
        axios
          .patch(`/api/system/${opts.id}`, { rpiMacAddress: opts.macAddress, hasRpiClient: true })
          .then(({ data }) => {
            resolve(data)
          }).catch((error) => reject(error))
      })
    }
  },
  clientKey (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/system/${opts.id}/get-client-key`)
        .then(({ data }) => {
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  clientExe (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/client/make-exe', { params: opts })
        .then(({ data }) => {
          resolve(data)
        }).catch((error) => {
          console.log(`clientExe: ${error}`)
          reject(error)
        })
    })
  },
  clientExeUrl (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/client/get-exe-link?id=${opts.id}&model=system`)
        .then(({ data }) => {
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  clientResetConnected (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`/api/system/${context.state.current.id}`, { keyConnected: false })
        .then(({ data }) => {
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  uploadKeys (context, opts) {
    const inputs = { params: { name: opts.file.name, date: opts.file.lastModified, fileset: opts.fileset, size: opts.size } }
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/system/${opts.id}/get-upload-keys`, inputs)
        .then(({ data }) => {
          context.commit('UPDATE_BACKUP_METHOD')
          resolve(data)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  s3SplitBackupsList (context, opts) {
    const inputs = { params: { s3Key: opts.s3Key } }
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/system/${opts.id}/get-s3-split-backups`, inputs)
        .then(({ data }) => {
          context.commit('S3_BACKUPS_LIST', data)
          resolve(data)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  async scan (context, opts) {
    await axios.post(`/api/system/${opts.system}/scan`, opts)
  },
  alarms (context) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/system/alarms')
        .then(({ data }) => {
          context.commit('ALARMS', data)
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  // disableAlarm (context) {
  //   let opts = { alarmed: false }
  //   return new Promise((resolve, reject) => {
  //     axios
  //       .patch(`api/system/${context.state.current.id}`, opts)
  //       .then(({ data }) => {
  //         context.commit('DISABLE_ALARM')
  //         resolve(data)
  //       }).catch((error) => reject(error))
  //   })
  // },
  rescanAlarm (context, id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/system/${id}/rescan-alarm`)
        .then(() => {
          resolve()
        }).catch(error => reject(error))
    })
  },
  rescanAlarms (context) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/system/rescan-alarms')
        .then(() => {
          context.dispatch('alarms')
          resolve()
        }).catch((error) => reject(error))
    })
  },
  async overdue (context, opts = {}) {
    try {
      const { data } = await axios.get('/api/system/overdue', { params: { scope: opts.scope } })
      context.commit('OVERDUE_LIST', data)
    } catch (err) {}
  },
  async notBackedUp (context, opts = {}) {
    try {
      const { data } = await axios.get('/api/system/not-backedup', { params: { scope: opts.scope } })
      context.commit('NOT_BACKEDUP_LIST', data)
    } catch (err) {}
  },
  scanbackupMethods (context) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/system/backup-kind-check')
        .then(() => {
          resolve()
        }).catch((error) => reject(error))
    })
  },
  updatebackupMethod (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`/api/system/${opts.id}`, { backupMethod: opts.backupMethod })
        .then(() => {
          resolve()
        }).catch((error) => reject(error))
    })
  },
  resyncBackups (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/system/${opts.id}/resync-backups`)
        .then(({ data }) => {
          resolve(data)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  async deleteBackup (context, opts) {
    try {
      // TODO: deal with errors
      await axios.delete(`/api/system/${opts.id}/delete-backup`, { params: { backup: opts.backup } })
    } catch (error) {
      console.log(error)
    }
  },
  async clientSignal (context, opts) {
    try {
      const params = {
        id: opts.id,
        type: 'system',
        signal: opts.signal
      }
      if (opts.handoffToOrg !== undefined) {
        params.handoffToOrg = opts.handoffToOrg
      }
      await axios.post('/api/client/signal', params)
    } catch (err) {
      console.log(err)
    }
  },
  async clearClientInfo (context, opts) {
    try {
      await axios.get(`/api/system/${opts}/clearClientInfo`)
    } catch (err) {
      console.log(err)
    }
  },
  async esVersionScan (context, opts) {
    try {
      await axios.post('/api/system/esversion-scan')
    } catch (err) {
      console.log(err)
    }
  }
}
